import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
const ALL_ORGS_OVERRIDE_KEY = 'allOrgsOverride';
export const redirectToImport = ({ hashRoute, absolutePath, allOrgsOverride = false, }) => {
    localStorage.setItem(ALL_ORGS_OVERRIDE_KEY, allOrgsOverride ? 'true' : 'false');
    const { origin } = window.location;
    if (absolutePath) {
        window.location.href = `${origin}${absolutePath}`;
        return;
    }
    const { queryString } = getQueryParamsAndQueryString();
    window.location.href = `${origin}/${queryString}${hashRoute ?? ''}`;
};
//# sourceMappingURL=import-redirect.js.map